import {
  ErrorBanner as SharedErrorBanner,
  type ErrorBannerProps as SharedProps,
} from "../../../ui/ErrorBanner.js";
import type { AccessibleError } from "../model/types.js";

export interface ErrorBannerProps {
  readonly error: AccessibleError | null;
  readonly onDismiss?: () => void;
  readonly onRetry?: () => void;
}

export function ErrorBanner(props: ErrorBannerProps) {
  const requiresAmoLogin =
    props.error?.code === "unauthenticated" ||
    props.error?.code === "session_expired" ||
    props.error?.code === "session_revoked";
  const shared: SharedProps = {
    error:
      requiresAmoLogin && props.error
        ? {
            ...props.error,
            message: "Откройте календарь из карточки сделки AmoCRM, чтобы войти.",
          }
        : props.error,
    title: requiresAmoLogin
      ? "Требуется вход через AmoCRM"
      : "Не удалось применить изменение расписания",
    testId: "manager-error",
    ...(props.onDismiss ? { onDismiss: props.onDismiss } : {}),
    ...(props.onRetry ? { onRetry: props.onRetry } : {}),
  };
  return <SharedErrorBanner {...shared} />;
}
